@let masterSlotIndex = 0;
@let masterSlot = slots()[masterSlotIndex];
@switch (masterSlot!.type) {
    @case (slotType.AddressAutocompleteInputSlot) {
        <ca-slot-address-autocomplete-input
            class="slot-type__{{ masterSlot?.type | slotTypeCssClass }}"
            [attr.data-testid]="'slot-' + masterSlotIndex + '-' + questionBlockId()"
            [slot]="masterSlot!"
            [citySlot]="slots()[1]!"
            [form]="form()"
            [slotIndex]="masterSlotIndex"
            [markAsTouched]="markAsTouched()"
            [questionBlockValidations]="questionBlockValidations() | targetSlotValidations: masterSlot.id"
            [questionBlockId]="questionBlockId()"
            [devMode]="devMode()"
            [ngModel]="value()"
            (ngModelChange)="onValueChange(slots(), $event)"
        ></ca-slot-address-autocomplete-input>
    }
    @default {
        <div class="slot-unsupported">
            {{ 'COMMON.INFO.UNSUPPORTED_SLOT_TYPE' | translate: { slotType: masterSlot?.type } }}
        </div>
    }
}
